import React, {useState} from 'react';

export const ThemeContext = React.createContext();

export const ThemeContextProvider = props => {
	const theme = {
		light: {
			type: 'light',
			primary: '#fdd135',
			primaryDark: '#fdd135',
			primaryLight: '#fdd135',
			secondary: '#000',
			secondaryDark: '#000',
			secondaryLight: '#000',
			text: 'gray',
			textDark: 'black',
			textLight: 'white',
			blue: '#27c9fe',
			green: '#88ca1b',
			red: '#ff1313',
			gray: '#828282',
			black: 'black',
			yellow: '#fdd135',
			brandYellow : "#F7CF46",
			brandBlack : "#1D1D1B",
			font: {
		
				body32: 2.4,
				body30: 2.0,
				body28: 1.5,
				body25: 1.1,
				body14: 1,
				body12: 0.8,
				body11: 0.7,
				body10: 0.6,
				body9: 0.5,
			},
		},
		dark: {
			type: 'dark',
			primary: '#212121',
			text: 'white',
		},
		
	};

	const setTheme = type => {
		setState({...state, theme: type === 'dark' ? theme.light : theme.dark});
	};

	const initState = {
		theme: theme.light,
		setTheme: setTheme,
	};

	const [state, setState] = useState(initState);

	return <ThemeContext.Provider value={state}>{props.children}</ThemeContext.Provider>;
};
